module.exports = __webpack_public_path__ + "static/media/measure3.6d0db09e.png";